import { NormalizedPermissions } from "./types";

export const normalizeKeyId = (key: string): string => (key ?? "").trim().toUpperCase();
export const normalizeGroupId = (group: string): string => (group ?? "").trim().toLowerCase();
export const normalizeWorkflowId = (workflow: string): string => (workflow ?? "").trim().toLowerCase();

export const EMPTY_PERMISSIONS: NormalizedPermissions = {
  loaded: false,
  keys: {},
  groups: {},
  workflows: {},
  isViewOnly: false,
};

export const normalizePermissions = (currentUserResponse: any): NormalizedPermissions => {
  const userPermissions = currentUserResponse?.userPermissions;
  const userFeatureKeys = userPermissions?.userFeatureKeys;
  const userWorkFlow = userPermissions?.userWorkFlow;

  if (!Array.isArray(userFeatureKeys)) {
    return EMPTY_PERMISSIONS;
  }

  const keys: Record<string, true> = {};
  const groups: Record<string, true> = {};
  for (const featureKey of userFeatureKeys) {
    const key = normalizeKeyId(featureKey?.featureKey);
    if (key) keys[key] = true;

    const group = normalizeGroupId(featureKey?.featureGroupName);
    if (group) groups[group] = true;
  }

  const workflows: Record<string, true> = {};
  if (Array.isArray(userWorkFlow)) {
    for (const workFlow of userWorkFlow) {
      const workflow = normalizeWorkflowId(workFlow?.workFlowName);
      if (workflow) workflows[workflow] = true;
    }
  }

  return {
    loaded: true,
    keys,
    groups,
    workflows,
    isViewOnly: currentUserResponse?.isHayesViewOnlyUser === true,
  };
};
